import { PaymentApi } from "@app/services/apiServices/PaymentApi";
import { PaymentRequest } from "@app/models/PaymentRequest";
import { HomeownerApi } from "@app/services/apiServices/HomeownerApi";
import { SpinnerService } from "@app/services/spinner.service";
import { NetworkErrorService } from "@app/services/NetworkError.service";
import { FeatureFlagService } from "@app/services/feature-flag.service";
import { PaymentSuccessInfo } from "@app/models/PaymentSuccessInfo";
import { PrintService } from "@app/services/Print.service";
import { PaymentStore } from "@app/services/stores/PaymentStore";
import { take } from "rxjs/operators";
import { Component, Inject, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { DialogPreCancelComponent } from "@app/components/sharedDialogs/dialogPreCancel.component";
import { DialogErrorDialog } from "@app/components/sharedDialogs/dialogError.dialog";
import { AppDate } from "@app/util/app-date";
import { Router } from "@angular/router";
import { WindowToken } from "@app/util/window.token";
import { ContentApi } from "@app/services/apiServices/ContentApi";
import { UserStore } from "@app/services/stores/UserStore";

/**
 * Created by req89873 on 12/02/16.
 */
@Component({
    selector: 'app-payment-success',
    template: require('./paymentsuccess.component.html')
})

export class PaymentSuccessComponent implements OnInit {
    paymentRequest: PaymentRequest;
    email: string;
    paymentConfirmationNumber: any;
    paymentId: number;
    paymentSuccessInfo: PaymentSuccessInfo;
    thankYouMsg;
    isAsyncFeatureEnabled: boolean = false;

    /** accepted values: payment, schedule. This var controls the UI passed on what was successful. */
    successDisplay: "payment" | "schedule" = "payment";
    paymentDate: any;

    constructor(
        @Inject(WindowToken) private window,
        @Inject(MatDialog) private dialog: MatDialog,
        @Inject(PaymentApi) private paymentApi: PaymentApi,
        @Inject(SpinnerService) private spinnerService: SpinnerService,
        @Inject(NetworkErrorService) private networkErrorService: NetworkErrorService,
        @Inject(PaymentStore) private paymentStore: PaymentStore,
        @Inject(HomeownerApi) private homeownerApi: HomeownerApi,
        @Inject(PrintService) private printService: PrintService,
        @Inject(FeatureFlagService) private featureFlagService: FeatureFlagService,
        @Inject(Router) private router: Router,
        @Inject(ContentApi) private ContentApi: ContentApi,
        @Inject(UserStore) private userStore: UserStore
    ) {}

    ngOnInit() {
        this.fetchThankYouMessage();
        this.paymentSuccessInfo = this.paymentStore.getPaymentSuccessInfo()
        this.isAsyncFeatureEnabled = this.featureFlagService.isAsyncFeatureEnabled();

        if (this.paymentSuccessInfo) {
            this.successDisplay = this.paymentSuccessInfo.paymentType;
            this.paymentId = this.paymentSuccessInfo.paymentId;
            this.paymentConfirmationNumber = this.paymentSuccessInfo.confirmationNumber;
            this.email = this.paymentSuccessInfo.email;

            // For Async flow, we don't expect confirmation number
            if (this.isAsyncFeatureEnabled && this.successDisplay === 'payment') {
                this.paymentConfirmationNumber = null;
            }
        } else {
            console.error("Opened payment success without data. Redirecting to properties landing.")
            this.goToHOAPay()
        }
        this.paymentRequest = this.paymentStore.getPaymentRequest();
    }

    fetchThankYouMessage() {
        this.ContentApi.fetchGlobalContentByLocationType('ppthank')
            .pipe(take(1)).subscribe(resp => {
                this.thankYouMsg = resp && resp ? decodeURIComponent(resp.msg) : ''
            });
    }

    goToHOAPay() {
        this.router.navigateByUrl('/properties');
    }
    getEndDateF(format = "MM/dd/yyyy"): string {
        if (this.paymentSuccessInfo.paymentType === 'schedule') {
            const endDate = this.paymentSuccessInfo.paymentScheduleRequest.endDate
            return AppDate.fromString(endDate.formattedFullDate, "MM/dd/yyyy").format(format)
        }
        return ''
    }

    isPaymentDateToday() {
        let today = new Date().toDateString();
        if (this.paymentSuccessInfo) {
            this.paymentDate = new Date(this.paymentSuccessInfo.paymentDate.formattedFullDate).toDateString();
        }

        return today === this.paymentDate;
    }

    cancelPreCancel() {
        let dialog = this.dialog.open(DialogPreCancelComponent, {
            data: { paymentAmount: this.paymentSuccessInfo.totalPaymentAmount }
        });
        dialog.afterClosed().pipe(take(1)).subscribe(value => {
            if (value === 'cancel') {
                this.spinnerService.showSpinner();
                this.paymentApi.deletePayment(false, this.paymentSuccessInfo.paymentId)
                    .pipe(take(1)).subscribe((resp) => {
                        this.spinnerService.closeSpinner();
                        if (resp.status === 200) {
                            this.router.navigateByUrl('/properties/paymentCancel', { state: { 'email': this.email,
                                'paymentRequest': this.paymentRequest,
                                'paymentConfirmationNumber': this.paymentConfirmationNumber,
                                'paymentId': this.paymentId
                            } } )
                        } else {
                            let errDialog = this.dialog.open(DialogErrorDialog);
                            errDialog.afterClosed().pipe(take(1)).subscribe(data => {
                                if (data === 'Retry') {
                                    this.cancelPreCancel();
                                }
                            });
                        }
                    }, (err) => {
                        this.networkErrorService.handleNetworkError(err, true).pipe(take(1)).subscribe((resp) => {
                            if (resp === true) {
                                this.cancelPreCancel();
                            }
                        });
                    });
            }
        });
    }

    clickPrint() {
        this.printService.print("Cancelled Payment", "Clicked print button")
    }

    openUrl(url) {
        window.open(url, '_blank');
    }

    gotoSchedEdit() {
        if(this.paymentSuccessInfo.paymentType === 'schedule' && this.paymentSuccessInfo.scheduleInfo?.frequency.toLowerCase() === 'one-time') {
            this.router.navigateByUrl('/properties/oneTimeEdit/' + this.paymentSuccessInfo.paymentId,
                { state: { scheduleId: this.paymentSuccessInfo.paymentId } });
        } else {
            this.router.navigateByUrl('/properties/scheduleEdit/' + this.paymentSuccessInfo.paymentId,
                { state: { scheduleId: this.paymentSuccessInfo.paymentId } });
        }
    }
}
